import styled from 'styled-components'

export const SignalFeedbackContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 24px;
`
